import React, { useState } from "react";
import { useProductTexts, useUrls } from "Store/texts/hooks";

import { getProductDetailsList } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/utils";
import { useTexts } from "Components/TextContext";
import { ThemedButton } from "Components/Themes/components/ThemedButton";
import { useIsAdvisorCart } from "Store/cart/cartHooks";
import { InsuranceProduct } from "Store/interfaces/products/checkout";
import { getFMSProductName } from "Store/texts/helpers/FMSproductName";
import { buttonDetailsTrackId } from "Utils/analytics";
import { useUnleashFeatureFlag } from "Utils/unleash";
import { FeatureFlagTask } from "Utils/unleash/flags";
import { FooterProductDetails } from "../FooterProductDetails";
import { FooterContainer } from "../styled";
import { ButtonContainer } from "./styled";

interface Props {
  readonly product: InsuranceProduct;
  readonly showDetails?: boolean;
}

export const CardFooter = ({
  product,
  showDetails: defaultShowDetails = false,
}: Props): React.ReactElement => {
  const [showDetails, toggleDetails] = useState<boolean>(defaultShowDetails);
  const [productText, lang] = useProductTexts(getFMSProductName(product.name));
  const { getText } = useTexts();
  const [urls] = useUrls();
  const isAdvisorOffer = useIsAdvisorCart();
  const featureToggleGeodata = useUnleashFeatureFlag(
    FeatureFlagTask.SSX_1556_GEODATA_PM,
  );

  const productDetails = getProductDetailsList(
    product,
    productText.types,
    lang,
    urls,
    featureToggleGeodata,
  );

  const hasDetails = productDetails.length > 0;

  const handleToggleDetails = (): void => {
    toggleDetails(!showDetails);
  };

  return (
    <FooterContainer className="insurance-details-card__footer">
      <ButtonContainer>
        <ThemedButton
          variant="text"
          trackId={buttonDetailsTrackId("not-editable")}
          onClick={handleToggleDetails}
          hidden={!hasDetails && !isAdvisorOffer}
          iconRight={showDetails ? "chevron-up" : "chevron-down"}
        >
          {getText("insurancecard.button.details")}
        </ThemedButton>
      </ButtonContainer>

      <FooterProductDetails
        product={product}
        showDetails={showDetails}
        productDetails={productDetails}
      />
    </FooterContainer>
  );
};
